// extracted by mini-css-extract-plugin
export default {"container":"MqtB69","messageElement":"h5lEOe","noWrap":"D7Jus2","logo":"flQkdS","ctaLink":"DAmdeS","hidden":"KzvmAg"};